/* eslint-disable */
/**
 * IMA Script tag content
 */
(function(window, document, type, name, src, preload, script, esm, ncl) {
  // Save provided global object key as value in window
  name = window.IMAGlobalObject = name;
  // Initiate command queue, which will be later orchestrated by the sensor when loaded and interpreted by the browser.
  // The command queue is the only supported interface to send commands to it.
  window[name] =
    window[name] ||
    function() {
      (window[name].q = window[name].q || []).push(arguments);
    };
  // Get preload when available
  preload = document.querySelector('[data-name=' + name + ']');
  // Set script src to preload href or to a provided dsn
  src = !!src && !preload ? src + '/sensor.modern.ncl.min.js' : preload.href;
  // Memoize the script source onto IMA global object for checking where the publisher has loaded the sensor script
  window[name]['src'] = src;
  // Create script
  script = document.createElement(type);
  // Check if browser supports native crypto (Crypto.subtle)
  ncl = window.crypto && window.crypto.subtle;
  // Check if browser supports module type (aka ES6) and load the legacy script when not
  // This is the most important step in the tag. It loads the ES6 code of the sensor or fallback to a ES3 version of the sensor
  // The ES6 version of the sensor is smaller by a factor of ~ 5
  esm = 'noModule' in script && !/Edge/.test(window.navigator.userAgent);
  // Choosing the correct sensor based on es6 compatibility and availability of native encryption
  script.src = esm ? (ncl ? src : src.replace('.ncl', '.lcl')) : src.replace('.modern.n', '.legacy.l');
  // Append script to head (parent of src)
  document.head.appendChild(script);
})(window, document, 'script', 'ima');
